import { render, staticRenderFns } from "./ClusterIcon.vue?vue&type=template&id=3ffe6a8b&"
import script from "./ClusterIcon.vue?vue&type=script&lang=js&"
export * from "./ClusterIcon.vue?vue&type=script&lang=js&"
import style0 from "./ClusterIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports